import { render, staticRenderFns } from "./SeatingCardsPrint.vue?vue&type=template&id=05956a7e&scoped=true"
import script from "./SeatingCardsPrint.vue?vue&type=script&lang=js"
export * from "./SeatingCardsPrint.vue?vue&type=script&lang=js"
import style0 from "./SeatingCardsPrint.vue?vue&type=style&index=0&id=05956a7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05956a7e",
  null
  
)

export default component.exports